import React from 'react';
import { Neo } from '@singularsystems/neo-react';

interface ICollapsibleCardProps {
    title: string,
    children: any,
    icon?: string,
    isExpanded: boolean,
    onClickCallback?: any
}

interface ICollapsibleCardState {
    isExpanded: boolean,
    icon?: string,
}

class CollapsibleCard extends React.Component<ICollapsibleCardProps, ICollapsibleCardState>{

    constructor(props: ICollapsibleCardProps) {
        super(props);

        this.state = {
            isExpanded: this.props.isExpanded
        }
        this.toggleCard = this.toggleCard.bind(this);
    }

    toggleCard() {

        this.setState(previousState => ({
            isExpanded: !previousState.isExpanded
        }))

        if (this.props.onClickCallback) {
            this.props.onClickCallback()
        }
    }

    public render() {
        const header: JSX.Element = <div className="header-div" onClick={this.toggleCard}>
            <i className={"fa fa-" + (this.state.isExpanded ? "caret-down" : "caret-right")} />
        </div>

        const display = {
            display: this.state.isExpanded ? 'block' : 'none'
        }

        return (
            <Neo.Card headerElements={header} icon={this.props.icon} title={this.props.title} className="m-1">
                <div style={display}>
                    {this.props.children}
                </div>
            </Neo.Card>
        )
    }
}

export default CollapsibleCard;